import React, { memo } from 'react';

export default memo(function EditIcon(props:any) {
	return (
		<svg version="1.1" id="Layer_1" x="0px" y="0px" width={props.width ? props.width : "48px"} height={props.height ? props.height : "48px"} viewBox="0 0 48 48">
			<g fill={props.color ? props.color : '#888'}>
				<path d="M34.4,40.8H14c-3.8,0-6.9-3.2-6.9-7.2v-19c0-4,3.1-7.2,6.9-7.2h17.4c0.7,0,1.2,0.6,1.2,1.2s-0.6,1.2-1.2,1.2
					H14c-2.4,0-4.4,2.1-4.4,4.7v19c0,2.6,2,4.7,4.4,4.7h20.4c2.4,0,4.4-2.1,4.4-4.7v-5.8c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2v5.8
					C41.4,37.5,38.3,40.8,34.4,40.8z"></path>
				<path d="M22.7,32.7c-0.3,0-0.6-0.1-0.9-0.4c-0.2-0.2-0.4-0.6-0.4-0.9l0.1-3.5c0-0.3,0.1-0.6,0.4-0.8l17-17
					c0.5-0.5,1.3-0.5,1.8,0l3.4,3.4c0.5,0.5,0.5,1.3,0,1.8l-17,17c-0.2,0.2-0.5,0.4-0.8,0.4L22.7,32.7C22.7,32.7,22.7,32.7,22.7,32.7z
					M24,28.5l0,1.7l1.7,0l15.8-15.8l-1.6-1.6L24,28.5z"></path>
			</g>
		</svg>
	);
});